<template>
  <div>
          <el-table
        ref="tableRef"
        empty-text="暂无数据,敬请期待。"
        border
        :data="render_list"
        row-key="node_id"
        :default-expand-all="defaultExpandAll"
        :tree-props="{ children: 'child' }"
        :style="{
          width: '1200px',
        }"
      >
      <el-table-column
        :resizable="false"
        label="评测项"
        :show-overflow-tooltip="true"
      >
        <template #default="scope">
          <span
            class="level_tag"
            v-if="
              data_type == 4
                ? scope.row.node_id < 4 && scope.row.node_id > 0
                : scope.row.is_leaf == 0 &&
                  scope.row.level > 0 &&
                  scope.row.level < 4
            "
            :style="{
              background:
                data_type == 4
                  ? '#649FEB'
                  : ['#649FEB', '#65C57C', '#F29D65'][scope.row.level - 1],
            }"
          >
            {{
              data_type == 4
                ? "创新类型"
                : ["一", "二", "三", "四", "五", "六"][scope.row.level - 1] +
                  "级评测项"
            }}
          </span>
          <span>
            {{ scope.row.node_name || scope.row.name }}
          </span>
          <el-popover
            v-if="
              scope.row.child &&
              Object.keys(scope.row.child).length == 0 &&
              data_type != 4
            "
            :tabindex="-1"
            placement="right"
            :width="400"
            trigger="hover"
          >
            <div class="rulePop">{{ scope.row.node_desc }}</div>
            <template #reference>
              <span class="tip_icon" @mouseenter="getRule(scope.row)"></span>
            </template>
          </el-popover>
        </template>
      </el-table-column>

      <template v-if="model_list && model_list.length > 0">
        <template v-for="(item, index) in model_list" :key="index">
          <el-table-column
            :resizable="false"
            label="得分"
            :width="[337, 214, 214][model_list.length - 1]"
          >
            <template #default="scope">
              <template v-if="scope && scope.row">
                <template
                  v-if="
                    scope.row.score[index] > -1 &&
                    scope.row.total_score[index] > 0 &&
                    (scope.row.node_id < 4
                      ? scope.row.name.indexOf('创新') == -1
                      : true)
                  "
                >
                  <tree-table-item
                    :data="{
                      type: 2,
                      score: scope.row.score[index],
                      total_score: scope.row.total_score[index],
                    }"
                  ></tree-table-item>
                </template>

                <template
                  v-else-if="
                    scope.row.node_id < 4 && scope.row.name.indexOf('创新') > -1
                  "
                >
                  <tree-table-item
                    :data="{
                      type: 4,
                      score: scope.row.score[index],
                      total_score: scope.row.total_score[index],
                    }"
                  ></tree-table-item>
                </template>
              </template>
            </template>
          </el-table-column>
        </template>
      </template>

      <el-table-column
        :resizable="false"
        label="详情"
        width="200"
        class-name="td_class"
      >
        <template #default="scope">
          <template v-if="scope && scope.row">
            <!-- <template v-if="model_list == 4">
              <span
                class="detail_tag"
                v-if="!scope.row.child"
                @click="getInnovateDetailInfo(scope.row)"
              >
                专家评价
              </span>
            </template> -->
            <template v-if="scope.row.is_leaf == 0">
              <!-- <span
                class="appraise_one_tag"
                v-if="scope.row.level == 1"
                @click="getEvaluation(scope.row, '专家综合评价')"
              >
                专家综合评价
              </span>
              <span
                class="appraise_two_tag"
                v-else-if="scope.row.level == 2"
                @click="getEvaluation(scope.row, '专家评价')"
              >
                专家评价
              </span>
              <span v-else> </span> -->
              <span></span>
            </template>
            <span
              class="detail_tag"
              v-else
              @click="
                getDetail(scope.row);
                showRuleDesc = false;
              "
            >
              详情
              <div class="cur_node_has_img" v-if="scope.row.has_img>0"></div>
              <div class="cur_node_has_video" v-if="scope.row.has_video>0"></div>
            </span>
          </template>
        </template>
      </el-table-column>
    </el-table>
    
    <el-drawer
      v-model="descDrawer"
      title=""
      direction="rtl"
      :before-close="handleClose"
      :size="'auto'"
      modal-class="modal_transparent"
    >
      <div class="one_evaluation_desc" v-if="evaluation_list && evaluation_list.length == 1">
        <div class="one_desc_tit">
          {{ evaluation_list[0].node_name }}-专家综合评价
        </div>
        <div
          class="one_desc_desc"
          v-html="evaluation_list[0].node_value.content"
        ></div>
      </div>
      <div class="more_evaluation_desc" v-else-if="evaluation_list && evaluation_list.length>0">
        <table class="table3">
          <tr>
            <td v-for="(item, ind) in model_list" :key="ind">
              <div class="table3_model_name">
                <!-- {{ item.brand + " " + item.model_name }}专家综合评价 -->
              </div>
            </td>
          </tr>
          <tr>
            <td
              class="table_bd_left"
              v-for="(item, ind) in model_list"
              :key="ind"
            >
              <div class="table_title_text">评价主体</div>
            </td>
          </tr>
          <tr>
            <td
              class="table_bd_left"
              v-for="(item, ind) in model_list"
              :key="ind"
            >
              <div class="table3_model_desc">
                <div
                  class="table3_model_content"
                  v-if="evaluation_list[ind].node_value.content"
                  v-html="evaluation_list[ind].node_value.content"
                ></div>
                <div
                  class="table3_model_experts"
                  v-if="evaluation_list[ind].node_value.evaluator"
                >
                  评价专家:{{ evaluation_list[ind].node_value.evaluator }}
                </div>
                <div
                  class="table3_model_time"
                  v-if="evaluation_list[ind].node_value.evaluate_time"
                >
                  {{
                    timestampToString(
                      evaluation_list[ind].node_value.evaluate_time
                    )
                  }}
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>

    <el-drawer
      v-model="dialogVisible"
      :title="node_name"
      direction="rtl"
      :before-close="handleClose"
      :size="'auto'"
      modal-class="modal_transparent"
    >
      <div class="my_dialog" v-if="dialogVisible">
        <table class="detail_table" border="1">
          <tr class="detail_title">
            <td class="detail_attr">车型</td>
            <template v-for="(item, ind) in model_list" :key="ind">
              <td class="detail_title_item" colspan="1">
                {{ item.model_name }}
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">
              <div>得分</div>
            </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div class="attr_box">
                  <div class="attr_node_score">
                    <span class="attr_node_score_num"
                      >{{
                        (item["1"] && item["1"].item_value_val) || 0
                      }}分</span
                    >
                  </div>
                </div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item" v-show="showRuleDesc == true">
            <td class="detail_attr">标准 <span id="triangle-up" @click="showRuleDesc=false"></span> </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['9'] && item['9']) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <!-- 背景色占位 -->
          </tr>
          <tr class="detail_tr_item" v-show="showRuleDesc == false">
            <td class="detail_attr">
              标准
              <span id="triangle-down" @click="showRuleDesc = true"></span>
            </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 5px;
                  "
                  class="detail_val_text"
                  v-html="(item['9'] && item['9']) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">主观评价</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['2'] && item['2'].item_value_val) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">客观信息</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['3'] && item['3'].item_value_val) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">图片素材</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item['4'] && item['4'].ext_info.length > 0">
                  <div class="detail_val_pic">
                    <div
                      class="detail_pic_left"
                      @click.stop="
                        previewImg(item['4'] && item['4'].ext_info, 'img')
                      "
                    >
                      <div class="detail_pic_left_img">
                        <img
                          :src="item['4'].ext_info[0].attach_value || ''"
                          alt="图片加载失败"
                        />
                        <span class="more_pic">{{
                          item["4"] && item["4"].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看图片</div>
                    </div>
                    <div
                      class="detail_pic_right detail_val_text"
                      v-if="item['4'] && item['4'].item_value_val"
                      v-html="item['4'] && item['4'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth(route_type)" @click="downloadFn(item['4'] && item['4'].ext_info,model_list[ind].model_name,node_name)"></div>
                </template>
                <div class="no_img" v-else>
                  当前测试子节点本次未涉及图片素材
                </div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">视频素材</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item['5'] && item['5'].ext_info.length > 0">
                  <div class="detail_val_video">
                    <div
                      class="detail_video_left"
                      @click.stop="
                        previewImg(item['5'] && item['5'].ext_info, 'video')
                      "
                    >
                      <div class="detail_pic_left_video">
                        <video controlsList="nodownload" :src="item['5'].ext_info[0].attach_value"></video>
                        <span class="more_pic">{{
                          item["5"] && item["5"].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看视频</div>
                    </div>
                    <div
                      class="detail_pic_right detail_val_text"
                      v-if="item['5'] && item['5'].item_value_val"
                      v-html="item['5'] && item['5'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth(route_type)" @click="downloadFn(item['5'] && item['5'].ext_info,model_list[ind].model_name,node_name)"></div>
                </template>
                <div class="no_img" v-else>
                  当前测试子节点本次未涉及视频素材
                </div>
              </td>
            </template>
          </tr>
        </table>
      </div>
    </el-drawer>
    <div class="my_swiper_dialog" v-if="swiperVisible">
      <div class="my_swiper_dialog_content">
        <div class="my_swiper_dialog_close" @click="closeSwiperDialog"></div>
        <swiper :list="preview_list" :type="preview_type" />
      </div>
    </div>
    <el-backtop 
      target=".el-main"
      :visibility-height="500"
      :right="50"
      :bottom="50"
    />
  </div>
</template>
<script>
/*---------合并树数据---------*/
let scoreMap = {},
  childMap = {},
  nodeMap = {},
  count = 0;
function hebing(data, is_cx) {
  count = data.length;
  let listMap = {};
  for (let k in data) {
    let list = data[k];
    for (let dd in list) {
      let d = JSON.parse(JSON.stringify(list[dd]));
      listMap[d["node_id"]] = mapList(d, k);
      setScoreMap(d["node_id"], d["total_score"], d["score"], k);
      nodeMap[d["node_id"]] = d;
    }
  }
  let tmpList = [];
  Object.values(listMap).forEach((l) => {
    l["total_score"] = fillArray(scoreMap[l["node_id"]]["total_score"]);
    l["score"] = fillArray(scoreMap[l["node_id"]]["score"]);
    tmpList.push(l);
  });
  let tree_list = rebuild(tmpList);
  scoreMap = {};
  childMap = {};
  nodeMap = {};
  count = 0;

  if (!is_cx) {
    let newMap = {};
    let result_list = [];
    for (let ti in tree_list) {
      newMap[tree_list[ti]["node_id"]] = tree_list[ti];
    }
    for (let di in data[0]) {
      result_list.push(newMap[data[0][di]["node_id"]]);
    }
    return result_list;
  } else {
    return tree_list;
  }
}
function rebuild(list) {
  let exitsArr = {};
  let newArr = Array();
  for (let key in list) {
    let l = list[key];
    if (!exitsArr[l["node_id"]]) {
      exitsArr[l["node_id"]] = true;
      if (childMap[l["node_id"]]) {
        let childList = [];
        for (let ckey in childMap[l["node_id"]]) {
          let c = childMap[l["node_id"]][ckey];
          let child = nodeMap[c];
          child["total_score"] = fillArray(
            scoreMap[child["node_id"]]["total_score"]
          );
          child["score"] = fillArray(scoreMap[child["node_id"]]["score"]);
          childList.push(child);
        }
        l["child"] = rebuild(childList);
      }
      newArr.push(l);
    }
  }
  return newArr;
}
function fillArray(arr) {
  for (let i = 0; i < count; i++) {
    if (typeof arr[i] == "undefined") {
      arr[i] = -1;
    }
  }
  return arr;
}
function mapList(list2, k) {
  let childlist2 = list2["child"];
  if (!childlist2) {
    return;
  }
  list2["child"] = {};
  if (childlist2.length > 0 || Object.keys(childlist2).length > 0) {
    for (let k1 in childlist2) {
      let child = childlist2[k1];
      if (
        !childMap[list2["node_id"]] ||
        childMap[list2["node_id"]].indexOf(child["node_id"]) == -1
      ) {
        if (!childMap[list2["node_id"]]) {
          childMap[list2["node_id"]] = [];
        }
        childMap[list2["node_id"]].push(child["node_id"]);
      }
      setScoreMap(child["node_id"], child["total_score"], child["score"], k);
      list2["child"] = {};
      list2["child"][child["node_id"] + ""] = mapList(child, k);
      nodeMap[child["node_id"]] = child;
    }
  } else {
    setScoreMap(list2["node_id"], list2["total_score"], list2["score"], k);
  }
  return list2;
}
function setScoreMap(node_id, total_score, score, k) {
  if (!scoreMap[node_id]) {
    scoreMap[node_id] = {};
  }
  if (!scoreMap[node_id]["total_score"]) {
    scoreMap[node_id]["total_score"] = {};
  }
  if (!scoreMap[node_id]["score"]) {
    scoreMap[node_id]["score"] = {};
  }
  scoreMap[node_id]["total_score"][k] = total_score;
  scoreMap[node_id]["score"][k] = score;
}

import { getTestDetailV2 } from "@/api";
import { getTestDetail as getTestDetailV22 } from "@/api_drive";
import {
  ElTable,
  ElTableColumn,
  ElBacktop,
  ElDrawer,
  ElMessage
  // ElPopover,
} from "element-plus";
import Swiper from "@/components/swiper/Swiper.vue";
import TreeTableItem from "@/components/common/views/treeTable/TreeTableItem.vue";
import { watch, toRefs, ref, defineExpose } from "vue";
import store from "@/store";
export default {
  name: "TreeTableBase",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    data_type: {
      type: Number,
      default: 0,
    },
    model_list: {
      type: Array,
      default: () => [],
    },
    route_type: {
      type: String,
      default: "",
    },
    defaultExpandAll: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    TreeTableItem,
    ElTable,
    ElTableColumn,
    ElBacktop,
    ElDrawer,
    Swiper
    // ElPopover,
  },
  setup(props) {
    let { data, model_list,route_type} = toRefs(props);
    const loading = ref(true);
    const render_list = ref([]);
    const tableRef = ref(null);
    const renderFn = (res_list) => {
      render_list.value = hebing(
        res_list.map((res) => {
          return res.data.list;
        })
      );
      loading.value = false;
      // }
    };

    watch(data, (new_val) => {
      if(new_val){
        renderFn(JSON.parse(JSON.stringify(new_val)));
      }
    });
    const node_name = ref("");
    const evaluation_list = ref([]);
    const descDrawer = ref(false);
    const getEvaluation = (row, type) => {
      console.log(type)
      node_name.value = row.node_name || row.name;
      let node_id = row.node_id || row.id;
      let promise_list2 = model_list.value.map((item) => {
        return new Promise((resolve, reject) => {
          let promise_method = route_type.value == 'drive'?getTestDetailV22:getTestDetailV2;
          promise_method({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promise_list2).then((res_list) => {
        evaluation_list.value = res_list.map((res) => {
          let item_value = {};
          if (res.data) {
            item_value = {
              node_name: res.data.node_name,
              node_value: res.data.node_value,
            };
          }
          // if(res.data && res.data.item_value){
          //     res.data.item_value.forEach((item)=>{
          //         item_value[item.item_value_val_type] = item;
          //     })
          // }
          return item_value;
        });
        descDrawer.value = true;
      });
    };
    const handleClose = (done) => {
      done();
    };

    //获取详情数据
    const detail_list = ref([]);
    const dialogVisible = ref(false);
    const getDetail = (row) => {
      node_name.value = row.node_name || row.name;
      let node_id = row.node_id || row.id;
   
      let promise_list2 = model_list.value.map((item) => {
        return new Promise((resolve, reject) => {
           let promise_method = route_type.value == 'drive'?getTestDetailV22:getTestDetailV2;
          promise_method({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
        });
      });
      Promise.all(promise_list2).then((res_list) => {
        detail_list.value = res_list.map((res) => {
          let item_value = {};
          if (res.data && res.data.item_value) {
            res.data.item_value.forEach((item) => {
              item_value[item.item_value_val_type] = item;
            });
            item_value["9"] = res.data["node_desc"];
          }
          return item_value;
        });
        console.log(detail_list.value);
        dialogVisible.value = true;
      });
    };

    const swiperVisible = ref(false);
    const preview_list = ref([]);
    const preview_type = ref("img");
    const previewImg = (list, type) => {
      preview_list.value = list;
      preview_type.value = type;
      swiperVisible.value = true;
    };
    const closeSwiperDialog = () => {
      document.querySelectorAll("video").forEach((item) => {
        item.pause();
      });
      swiperVisible.value = false;
    };

    const showRuleDesc = ref(false);

    const downloadFn = (list,model_name,node_name)=>{
      store.addDownload(list,model_name,node_name);
      ElMessage.success("已添加到下载队列中")
    }

    // 递归展开/折叠所有行的方法
    const expandAllRows = () => {
      if (tableRef.value && render_list.value.length > 0) {
        render_list.value.forEach(row => {
          expandRowRecursively(row, true);
        });
      }
    };

    const collapseAllRows = () => {
      if (tableRef.value && render_list.value.length > 0) {
        render_list.value.forEach(row => {
          expandRowRecursively(row, false);
        });
      }
    };

    const toggleAllRows = (expand) => {
      if (tableRef.value && render_list.value.length > 0) {
        render_list.value.forEach(row => {
          expandRowRecursively(row, expand);
        });
      }
    };

    // 递归展开/折叠单个行及其所有子节点
    const expandRowRecursively = (row, expand) => {
      if (tableRef.value) {
        // 展开/折叠当前行
        tableRef.value.toggleRowExpansion(row, expand);
        
        // 如果有子节点，递归处理所有子节点
        if (row.child && Array.isArray(row.child)) {
          row.child.forEach(child => {
            expandRowRecursively(child, expand);
          });
        }
      }
    };

    return {
      loading,
      render_list,
      tableRef,
      getEvaluation,
      handleClose,
      node_name,
      descDrawer,
      evaluation_list,

      getDetail,
      detail_list,
      dialogVisible,

      previewImg,
      preview_list,
      preview_type,
      swiperVisible,
      closeSwiperDialog,

      showRuleDesc,

      downloadFn,
      store,
      
      // 展开/折叠方法
      expandAllRows,
      collapseAllRows,
      toggleAllRows,
      expandRowRecursively
      
    };

    // 暴露方法给父组件
    // eslint-disable-next-line no-unreachable
    defineExpose({
      expandAllRows,
      collapseAllRows,
      toggleAllRows,
      expandRowRecursively
    });
  },
};
</script>

<style lang="less" scoped>
#triangle-up {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 10px solid;
}
#triangle-down {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 10px solid;
}
.level_tag {
  display: inline-block;
  width: 83px;
  height: 18px;
  border-radius: 9px;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  line-height: 18px;
  margin: 0 10px;
}
.tip_icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/c33656821a1100392efd965678caf39d.png)
    no-repeat center bottom;
  background-size: 17px 17px;
  margin-left: 10px;
}
.appraise_one_tag {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #dde5fd;
  font-size: 14px;
  color: #474747;
  cursor: pointer;
  position: absolute;
}
.appraise_two_tag,
.detail_tag {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #709ae8;
  cursor: pointer;
  position: absolute;
}
.detail_tag{
  justify-content: flex-start;
  padding-left: 70px;
  .cur_node_has_img{
    width: 19px;
    height: 16px;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/83321666601504_.jpg) no-repeat center center;
    background-size: 100%;
    margin-left: 10px;
  }
  .cur_node_has_video{
    width: 19px;
    height: 20px;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/83331666601504_.jpg) no-repeat center center;
    background-size: 100%;
    margin-left: 10px;
  }
}
:deep(.el-table__row > td:last-child) {
  height: 40px;
  padding: 0 0;
  .cell {
    padding: 10px;
    width: 100%;
    height: 100%;
    line-height: 40px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
:deep(.el-table__body-wrapper) {
  overflow: visible;
}

:deep(.el-table th){
  text-align: center;
}
:deep(.el-dialog) {
  // width:auto !important;
  max-width: 80vw;
  max-height: 70vh;
  margin: auto;
  overflow-y: auto;
  .el-dialog__body {
    overflow-x: auto;
  }
}


.detail_val_text {
  padding: 16px 17px;
  white-space: pre-line;
}
.no_img {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #777c89;
}
.detail_val_pic {
  display: flex;
  align-items: center;
  .detail_pic_left {
    width: 73px;
    height: 80px;
    cursor: pointer;
    .detail_pic_left_img {
      width: 73px;
      height: 60px;
      position: relative;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
  .detail_pic_right {
    font-size: 12px;
    font-weight: bold;
    color: #777c89;
    line-height: 16px;
  }
}
.detail_val_video {
  display: flex;
  align-items: center;
  .detail_video_left {
    width: 92px;
    height: 84px;
    cursor: pointer;
    .detail_pic_left_video {
      width: 92px;
      height: 64px;
      position: relative;
      video {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
}
.look_pic {
  width: 100%;
  height: 16px;
  font-size: 12px;
  color: #5287ea;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.my_dialog {
  width: auto;
  height: auto;
  background: #fff;
  border-radius: 15px;
  padding: 10px;
  // box-shadow: 11px 10px 26px 3px rgba(74, 97, 150, 0.16);
  max-width: 90vw;
  height: calc(100vh - 75px);
  overflow-x: auto;
  overflow-y: auto;
  // position: fixed;
  // top:50%;
  // left: 50%;
  // transform: translate(-50%,-50%);
  z-index: 99;
}

.my_swiper_dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  .my_swiper_dialog_content {
    width: auto;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .my_swiper_dialog_close {
      width: 50px;
      height: 50px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png) no-repeat center center;
      background-size: 50px 50px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40px;
      position: absolute;
      top: 40px;
      right: 40px;
      cursor: pointer;
      z-index: 2;
    }
  }
}

.detail_table2 {
  border-collapse: collapse;
  tr {
    background: #fff;
    td {
      border: 1px solid #dee6f2;
      text-align: center;
      padding: 10px;
    }
  }

  .table_tit {
    td {
      height: 44px;
    }
  }
  .td_model_info {
    width: 130px;
    .table_model_img {
      width: 100%;
      height: auto;
      img {
        width: 100%;
        height: auto;
      }
    }
    .table_model_name {
      margin-top: 10px;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      color: #474747;
      line-height: 16px;
    }
  }
  .td_node_name {
    width: 100px;
    font-size: 12px;
    font-weight: bold;
    color: #474747;
  }
  .td_score {
    width: 110px;
    font-size: 12px;
    color: #474747;
    line-height: 20px;
  }
  .td_score_two {
    width: 80px;
    font-size: 12px;
    color: #578ae9;
  }
  .td_node_two {
    width: 105px;
    font-size: 12px;
    font-weight: bold;
    color: #474747;
  }
  .td_evaluation {
    max-width: 480px;
    text-align: left;
    white-space: pre-line;
    p {
      padding: 10px;
      font-size: 12px;
      color: #777c89;
      line-height: 16px;
    }
  }
}

.one_evaluation_desc {
  max-width: 600px;
  min-width: 480px;
  padding: 0 50px;

  .one_desc_tit {
    height: 70px;
    line-height: 70px;
    font-size: 24px;
    font-weight: bold;
    color: #2b2b2b;
  }
  .one_desc_desc {
    font-size: 18px;
    font-weight: 400;
    color: #777c89;
    line-height: 30px;
  }
}
.more_evaluation_desc {
  padding: 0 10px;
  .table3 {
    border-collapse: collapse;
    td {
      &.table_bd_left {
        border-left: 1px solid #dee6f2;
        &:first-child {
          border: none;
        }
      }
      & > div {
        width: 350px;
        text-align: center;
      }
      .table3_model_name {
        height: 90px;
        font-size: 16px;
        font-weight: bold;
        color: #474747;
        line-height: 24px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .table_title_text {
        height: 32px;
        background: #f5f8fc;
        font-size: 12px;
        font-weight: bold;
        color: #474747;
        line-height: 32px;
      }
      .table3_model_desc {
        padding: 40px 30px 10px;
        font-size: 14px;
        color: #777c89;
        line-height: 20px;
        .table3_model_content {
          text-align: left;
          white-space: pre-line;
        }
        .table3_model_experts,
        .table3_model_time {
          text-align: right;
          margin-top: 12px;
        }
      }
    }
  }
}

:deep(.el-dialog) {
  width: auto;
  height: auto;
  max-width: 99vw;
  max-height: 99vh;
  margin: 0;
}

:deep(.modal_transparent) {
  background: transparent;
}

:deep(.el-drawer__body) {
  overflow-y: auto;
}
:deep(.el-progress-bar__innerText) {
  color: #000;
}

.table_tr_td_hebing {
  background: #fff;
}

.ext_btn {
  width: 80px;
  height: 80px;
  div{
    font-size:14px;
    margin-top: 10px;
    color: #709ae8;
  }
  cursor: pointer;
}
.color_E7816E {
  color: #e7816e;
}

</style>